export type CodeType =
  'UNKNOWN' |
  'NOT_FOUND' |
  'PERMISSION_DENIED' |
  'INTERNAL' |
  'DISCONNECT' |
  'NOT_AUTHENTICATED' |
  'INVALID_CREDENTIAL' |
  'INVALID_PROMOTION' |
  'NO_INTERNET' |
  'INVALID_PARAMS' |
  'USER_NOT_EXIST' |
  'FB_ACCOUNT_EXIST' |
  'FB_AUTH_DOMAIN' |
  'FB_POPUP_CANCELLED' |
  'FB_OPERATION_NOT_ALLOWED' |
  'FB_OPERATION_NOT_SUPPORTED' |
  'FB_POPUP_BLOCKED' |
  'FB_POPUP_CLOSED_BY_USER' |
  'FB_UNAUTHORIZED_DOMAIN'

export const errorCodesMap: { [x in CodeType]: string } = {
  USER_NOT_EXIST: 'userNotExist',
  UNKNOWN: 'unknownError',
  NOT_FOUND: 'notFound',
  PERMISSION_DENIED: 'permissionDenied',
  INTERNAL: 'internal',
  DISCONNECT: 'disconnectFromServer',
  NOT_AUTHENTICATED: 'notAuthenticated',
  INVALID_CREDENTIAL: 'invalidCredential',
  INVALID_PROMOTION: 'invalidPromotion',
  NO_INTERNET: 'noInternet',
  INVALID_PARAMS: 'invalidParams',
  FB_ACCOUNT_EXIST: 'auth/account-exists-with-different-credential',
  FB_AUTH_DOMAIN: 'auth/auth-domain-config-required',
  FB_POPUP_CANCELLED: 'auth/cancelled-popup-request',
  FB_OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
  FB_OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
  FB_POPUP_BLOCKED: 'auth/operation-not-supported-in-this-environment',
  FB_POPUP_CLOSED_BY_USER: 'auth/operation-not-supported-in-this-environment',
  FB_UNAUTHORIZED_DOMAIN: 'auth/unauthorized-domain'
};
